/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../connect/v2/resources/address';
import '../../../../address/service';
import '../../../../common/address';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ValidateAndStandardizeAddressRequest": {
                    "fields": {
                      "address": {
                        "type": ".squareup.connect.v2.resources.Address",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ValidateAndStandardizeAddressResponse": {
                    "fields": {
                      "validationStatus": {
                        "type": ".squareup.address.service.AddressResult.Status",
                        "id": 1,
                        "rule": "optional"
                      },
                      "validationLevel": {
                        "type": ".squareup.common.address.Verification.VerificationLevel",
                        "id": 2,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.connect.v2.resources.Address",
                        "id": 3,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 4,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ValidateAndStandardizeAddressRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ValidateAndStandardizeAddressResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ValidateAndStandardizeAddressRequest @ squareup/sfs/external/services/address/validate_and_standardize_address.proto at 12:1
 */
export const ValidateAndStandardizeAddressRequest = $root.lookupType('squareup.sfs.external.service.ValidateAndStandardizeAddressRequest');
fixType(ValidateAndStandardizeAddressRequest, {
  address: {
    required: true
  }
});
Builder.createAndAttachToType(ValidateAndStandardizeAddressRequest);
/**
 * SOURCE ValidateAndStandardizeAddressResponse @ squareup/sfs/external/services/address/validate_and_standardize_address.proto at 31:1
 */
export const ValidateAndStandardizeAddressResponse = $root.lookupType('squareup.sfs.external.service.ValidateAndStandardizeAddressResponse');
fixType(ValidateAndStandardizeAddressResponse, {
  validationStatus: {
    required: true
  }
});
Builder.createAndAttachToType(ValidateAndStandardizeAddressResponse);